import React from "react";
import { moneyFormat } from "../../lib/global_functions";
import { Col, Empty, Row, Tag, Typography } from "antd";
import { PictureOutlined } from "@ant-design/icons";

const { Text } = Typography;
export default function SettingExpandable({ record }) {
  return (
    <Row gutter={24}>
      <Col span={12}>
        {record.image_url ? (
          <img style={{ width: "100%" }} src={record.image_url} alt="slip" />
        ) : (
          <div
            style={{
              width: "100%",
              border: "1px solid white",
              padding: "300px 0px",
              textAlign: "center",
            }}
          >
            <PictureOutlined
              style={{
                fontSize: "68px",
                color: "#bfbfbf",
                marginBottom: "16px",
              }}
            />
            <br />
            <Text type="secondary">No photo available</Text>
          </div>
        )}
      </Col>
      <Col span={12}>
        <Row gutter={[12, 12]}>
          <Col span={8}>
            <Text>Transaction ID</Text>
          </Col>
          <Col span={16}>
            <Text copyable>{record.bank_trasnaction_id}</Text>
          </Col>

          <Col span={8}>
            <Text>Transaction Type</Text>
          </Col>
          <Col span={16}>
            <Tag color={record.type === "DEPOSIT" ? "lime" : "orange"}>
              <Text
                style={{
                  color: record.type === "DEPOSIT" ? "lime" : "orange",
                }}
              >
                {record.type === "DEPOSIT" ? "DEPOSIT" : "WITHDRAW"}
              </Text>
            </Tag>
          </Col>
          <br />
          <br />

          <Col span={8}>
            <Text>Amount</Text>
          </Col>
          <Col span={16}>
            <Text>
              {moneyFormat(record.amount || 0)}{" "}
              <span style={{ color: "green" }}>({record.currency})</span>
            </Text>
          </Col>

          <Col span={8}>
            <Text>Bank Info</Text>
          </Col>
          <Col span={16}>
            <Text>{record.bank_info}</Text>
          </Col>
          <Col span={8}>
            <Text>Direction</Text>
          </Col>
          <Col span={16}>
            <Text>{record.direction}</Text>
          </Col>
          <br />
          <br />

          <Col span={8}>
            <Text>Before Master Transaction</Text>
          </Col>
          <Col span={16}>{moneyFormat(record.old_creator_points || "-")}</Col>

          <Col span={8}>
            <Text>After Master Transaction</Text>
          </Col>
          <Col span={16}>{moneyFormat(record.new_creater_points || "-")}</Col>

          <br />
          <br />

          <Col span={8}>Before Transaction</Col>
          <Col span={16}>{moneyFormat(record.old_points)}</Col>

          <Col span={8}>Points</Col>
          <Col span={16}>{moneyFormat(record.points)}</Col>

          <Col span={8}>After Transaction</Col>
          <Col span={16}>{moneyFormat(record.new_points)}</Col>

          <br />
          <br />

          <Col span={8}>Note</Col>
          <Col span={16}>{record.note}</Col>
        </Row>
      </Col>
    </Row>
  );
}
